import superiorDireito from "../../assets/superiorDireito.png";
import inferiorDireito from "../../assets/inferiorDireito.png";
import centroEsquerdo from "../../assets/centroEsquerdo.png";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import style from "./RedefinirSenhaUsuario.module.css";
import { useState, useEffect } from "react";
import Logo from "../../assets/logoItera.png";
import UsuarioApi from "../../services/UsuarioApi";
import Alerta from "../../components/alerta/Alerta";
import Cookies from "js-cookie";
import Loader from "../../components/loader/Loader";
import { z } from "zod";
import InputNovaSenha from "../../components/inputNovaSenha/InputNovaSenha";

export default function RedefinirSenhaUsuario() {
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  const [botaoRedefinirInativo, setBotaoRedefinirInativo] = useState(true);

  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [loading, setLoading] = useState(false);



  // Função para fazer as verificações de senha
  const schema = z.object({
    senha: z
      .string()
      .min(8, "Mínimo 8 caracteres.")
      .regex(/[A-Z]/, "A senha deve conter pelo menos uma letra maiúscula.")
      .regex(/[0-9]/, "A senha deve conter pelo menos um número.")
      .regex(
        /[^A-Za-z0-9]/,
        "A senha deve conter pelo menos um caractere especial."
      ),
  });

  //Função de exibir alerta
  function exibirAlerta(mensagem, tipoAlerta) {
    setMensagemAlerta(mensagem);
    setTipoAlerta(tipoAlerta);
    setMostrarAlerta(true);
    setTimeout(() => {
      setMostrarAlerta(false);
    }, 3000);
  }


  // Função para validar a senha
  function validarSenha() {
    const resultado = schema.safeParse({ senha, confirmarSenha });

    if (!resultado.success) {
      const mensagensErro = resultado.error.issues
        .map((issue) => issue.message)
        .join("\n");
      exibirAlerta(mensagensErro, "danger");
      return false;
    }
    return true;
  }

  // Função para redefinir senha
  async function RedefinirSenha(e) {
    e.preventDefault();
    const tokenString = Cookies.get("token");

    if (validarSenha()) {
      try {
        const tokenObjeto = JSON.parse(tokenString);
        setLoading(true);
        await UsuarioApi.redefinirSenhaUsuarioPrimeiroLoginAsync(
          senha,
          tokenObjeto.jwt
        );

        await UsuarioApi.atualizarTokenLoginUsuario(
          senha,
          tokenObjeto.jwt
        );

        exibirAlerta("Informação atualizadas com sucesso!", "success");

      } catch (error) {
        console.error("Error during information update:", error);
        const mensagemErro = error.response
          ? error.response.data
          : "Erro ao atualizar informações.";
        exibirAlerta(mensagemErro, "danger");
      } finally {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    if (senha === "" && confirmarSenha === "") {
      setBotaoRedefinirInativo(false); // Desativa somente se estiverem vazios
    } else {
      setBotaoRedefinirInativo(senha === confirmarSenha); // Ativa somente se forem iguais
    }
  }, [senha, confirmarSenha]);


  return (
    <div className={style.conteudo}>
      <Alerta
        tipo={tipoAlerta}
        mensagem={mensagemAlerta}
        visivel={mostrarAlerta}
        aoFechar={() => setMostrarAlerta(false)}
      />
      {loading && <Loader />}
      <div className={style.conteudo_esquerda}>
        <img
          src={centroEsquerdo}
          alt="centroEsquerdo"
          className={style.centro_esquerdo}
        />
      </div>
      <div className={style.conteudo_login}>
        <img src={Logo} alt="logo" className={style.imagem_logo} />
        <h2 className={style.titulo_redefinir}>Redefinina sua Senha</h2>
        <p className={style.subtitulo_redefinir}>
          Como este é seu primeiro acesso, por favor, redefina sua senha para continuar.
        </p>
        <Form>
          <Form.Group className="mb-3" controlId={style.campos_senha}>
            <InputNovaSenha
              maxLength={50}
              type="password"
              placeholder="Senha"
              name="senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId={style.campos_senha}>
            <InputNovaSenha
              maxLength={50}
              type="password"
              placeholder="Confirmar Senha"
              name="confirmarSenha"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              required
            />
          </Form.Group>

          <Button onClick={RedefinirSenha} disabled={!botaoRedefinirInativo} variant="primary" type="submit" id={style.botao_entrar}>
            Redefinir senha
          </Button>
        </Form>
      </div>
      <div className={style.conteudo_direita}>
        <img
          src={superiorDireito}
          alt="superiorDireito"
          className={style.superior_direito}
        />
        <img
          src={inferiorDireito}
          alt="inferiorDireito"
          className={style.inferior_direito}
        />
      </div>
    </div>
  );
}
